import { use } from 'react';
import { DeviceDetailsProvider } from 'shared/providers/device-details/providers/device-details-provider';

import DeviceDetailsPopup from 'features/device/device-details/views/device-details-popup.component';
import DomipConfiguration from 'features/systems/domip/domip-configuration';
import { useSystemsContextProvider } from '../context/systems-provider';
import DomipInputs from './components/domip-inputs/domip-inputs-component';
import DomipOutputs from './components/domip-outputs/domip-outputs-component';
import DomipProviderContext from './providers/contexts/domip-provider-context';

const DomipSystemDetailsContent = (): React.JSX.Element => {
  const { selectedDeviceId } = use(DomipProviderContext);

  const {
    systemsDetailsHook: { refreshSystem },
  } = useSystemsContextProvider();

  return (
    <>
      <DomipConfiguration />
      <DomipInputs />
      <DomipOutputs />
      {selectedDeviceId && (
        <DeviceDetailsProvider deviceId={selectedDeviceId} initialViewingMode={'viewing'}>
          <DeviceDetailsPopup onCloseCallback={() => refreshSystem()} />
        </DeviceDetailsProvider>
      )}
    </>
  );
};

export default DomipSystemDetailsContent;
